/********************* 登录token *********************/
import Cookies from 'js-cookie'

let TokenKey = '';
if(process.env.VUE_APP_MODE == 'prod'){
    TokenKey = 'tumo_token';
} else {
    TokenKey = 'tumo_pre_token';
}
const host_name = process.env.VUE_APP_HOST_NAME;

const is_mobile = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null;
let cookieConfig = is_mobile ? {expires: 7} : {expires: 30};
if (host_name && host_name != 'localhost') {
    cookieConfig.domain = host_name;
    cookieConfig.path = '/';
}

/**
 * SZWB-Token
 * 获取、设置（doMain）、删除
 * @returns {*}
 */

export function getToken() {
    return Cookies.get(TokenKey);
}

export function setToken(token) {
    return Cookies.set(TokenKey, token, cookieConfig);
}

export function removeToken() {
    if (host_name == 'localhost') {
        return Cookies.remove(TokenKey);
    } else {
        Cookies.remove(TokenKey);
        Cookies.remove(TokenKey, {domain: location.hostname});
        return Cookies.remove(TokenKey, {domain: host_name});
    }
}
